.saveInfo {
  display: flex;
  margin-top: 16px;
  margin-bottom: 16px;
  align-content: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.saveInfoText {
  padding-right: 16px;
}

.actions {
  justify-content: space-around;
}

.spacer {
  flex: 1;
}

.fftContainer {
  min-height: 140px;
  max-height: 140px;
  flex: 1;
  align-items: center;
  border-color: var(--tuna-palette-divider);
  border-width: 2px;
  border-radius: var(--tuna-shape-radius-sm);
  justify-content: center;
}

.fft {
  position: relative;
  height: 100%;
  width: 100%;
  color: var(--tuna-palette-secondary-dark);
}

.meterRow {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.selfCenter {
  align-self: center;
}
